@if (hasReportingBasis) {
  <h2 class="fieldset-title">{{'ContextLabel' | translate}}</h2>
  <div class="field">
    <lm-lookup-basic
      [fieldLabel]="reportingBasis.label"
      [sourceField]="reportingBasis.fieldId"
      [lookupValue]="reportingBasis.value"
      [viewName]="'CubeStructure'"
      [selectListUrl]="reportingBasis.selectUrl"
      (lookupValueChangedEvent)="onContextValueChanged($event)"
      >
    </lm-lookup-basic>
  </div>
  <hr class="fieldset-hr">
  <h2 class="fieldset-title">{{'Dimensions' | translate}}</h2>
}
<lm-cube-dimensions-mapping
  [cubeBusClass]="cubeBusClass"
  [dimensionMapping]="dimensionMapping"
  [message]="message"
  [structures]="true"
  [hasReportingBasis]="hasReportingBasis"
  >
</lm-cube-dimensions-mapping>

